export enum CoreCatalogApiTags {
  CatalogItemList = 'CatalogItemList',
  CatalogMapCatalogItemList = 'CatalogMapCatalogItemList',
  CareerTagClouds = 'CareerTagClouds',
}

export const coreCatalogApiTagTypes = Array.from(Object.values(CoreCatalogApiTags));
